<div class="container">
  <section class="color-role-surface">
    <h2>{{ contact()?.display }}</h2>
  </section>
</div>
